import {DetailTable} from '../../../mapping-classes/detail-table';

export class VolmachtGrantees implements DetailTable {
  restrictedData;
  shieldedText;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(objects: any) {
    if (!objects || objects.length === 0) {
      this.createErrorMessage();
    } else {
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(objects);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen grantees.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'name',
      'involvedPartyCode',
    ];
  }

  setRowData(objects) {
    objects.forEach((object) => {
      this.rowData.push(object);
    });
  }

}
